import { useCallback, useEffect, useState } from 'react';
import type { ReminderWithNote } from '../services/api';
import { fetchReminders } from '../services/api';
import { useAuth } from './AuthContext';

export interface UseRemindersReturn {
  reminders: ReminderWithNote[];
  loading: boolean;
  refresh: () => Promise<void>;
}

export function useReminders(): UseRemindersReturn {
  const { user } = useAuth();
  const [reminders, setReminders] = useState<ReminderWithNote[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user?.id) return;
    try {
      const data = await fetchReminders();
      setReminders(data);
    } catch {
      // non-fatal
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  useEffect(() => {
    if (!user?.id) {
      setLoading(false);
      return;
    }
    load();
  }, [user?.id, load]);

  return { reminders, loading, refresh: load };
}
